import { useQuery } from '@tanstack/react-query';
import { UserRoomOrganizationInfo } from '@web-app/pages/api/user/organization';
import { useRouter } from 'next/router';

const getUserOrganizationData = async (roomName?: string) => {
  const userData = await fetch('/api/user/organization', {
    method: 'POST',
    body: roomName ? JSON.stringify({ roomName }) : null,
  }).then((response: any) => {
    if (!response.ok) {
      // soft fail.
      console.error(response);
    }
    return response.json();
  });

  return {
    ...userData,
  };
};

const expirationTime = 1000 * 60 * 60 * 2;

export const userDataKey = 'user-data';

export const useGetUserOrganizationData = () => {
  const router = useRouter();
  const roomName =
    (router.query as { roomId?: string }).roomId ??
    (router.query as { roomName?: string }).roomName;

  return useQuery({
    queryKey: [userDataKey, roomName],
    queryFn: (): Promise<UserRoomOrganizationInfo> =>
      getUserOrganizationData(roomName),
    gcTime: expirationTime,
    staleTime: expirationTime,
  });
};
